import type { IView } from '@barba/core';
import mousemoveGradients from '../components/mousemove-gradients';
import mainAdvantageVideos from '../components/main-advantage-videos';
import { LitPopupElement } from '../custom-elements/LitPopupElement/LitPopupElement';
import LazyLoad from 'vanilla-lazyload';

let mainVideoPopup: LitPopupElement | null;
let mainVideoPopupEl: HTMLVideoElement | null;

function onMainVideoPopupOpen() {
    if (mainVideoPopupEl) {
        LazyLoad.load(mainVideoPopupEl, {
            callback_loaded() {
                mainVideoPopupEl?.play();
            },
        });
    }
}

export default {
    namespace: 'new-main-page',

    beforeEnter({ next }) {
        mainVideoPopup = next.container.querySelector<LitPopupElement>(
            'app-lit-popup[data-lit-popup="main-video-popup"]',
        );
        mainVideoPopupEl = next.container.querySelector<HTMLVideoElement>('video.js-main-video-popup-el');
        mainVideoPopup?.addEventListener('open', onMainVideoPopupOpen);

        mousemoveGradients.init(next.container);
        mainAdvantageVideos.init(next.container);
    },

    beforeLeave({ current }) {
        mainVideoPopup?.removeEventListener('open', onMainVideoPopupOpen);
        mainAdvantageVideos.destroy(current.container);
    },

    afterLeave({ current }) {
        mousemoveGradients.destroy();
    },
} satisfies IView;
